import type { FC } from "react";
import type { HolidayNotice } from "../../../constants/holidayNotice";
import { Notice } from "./Notice";

type Props = {
  /**
   * 表示する告知。null なら何も描画しない。
   * 「今どの告知が有効か」の判定は呼び出し元 (ページ) の責務にして、本コンポーネントは
   * 渡されたものを描くだけに保つ (現在日に依存すると Storybook / テストで固定できないため)。
   */
  notice: HolidayNotice | null;
  className?: string;
};

/**
 * 長期休暇の告知バナー。文面と期間は `src/constants/holidayNotice.ts` で一元管理する。
 */
export const HolidayNoticeBanner: FC<Props> = ({ notice, className = "mb-6" }) => {
  if (!notice) return null;

  return (
    <Notice variant="warn" title={notice.title} className={className}>
      {notice.lines.map((line, index) => (
        <p key={line} className={index === 0 ? undefined : "mt-1"}>
          {line}
        </p>
      ))}
    </Notice>
  );
};
